<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/dashboard">
      <img v-if="showImage" class="img-logo" src="../assets/fundoAllto.d74dcfe7.png" />
      <img v-if="!showImage" class="img-logo-menor" src="../assets/allto.png" />
    </CSidebarBrand>

    <CRenderFunction
      flat
      :content-to-render="$options.nav_admin"
      v-show="tipo === 'Administrador' || tipo === 'Administrador-master'"
    />
    <CRenderFunction
      flat
      :content-to-render="$options.nav_profissional"
      v-show="tipo === 'Profissional'"
    />
    <CRenderFunction
      flat
      :content-to-render="$options.nav_recepcionista"
      v-show="tipo === 'Recepcionista'"
    />
    <!-- <CRenderFunction flat :content-to-render="$options.nav_saar" v-show="tipo === 'SAAR'"/>
      <CRenderFunction flat :content-to-render="$options.nav_pessoa" v-show="tipo !== 'SAAR' && tipo !== 'CLUBE' && tipo !== 'CONFEDERAÇÃO' && tipo !== 'FEDERAÇÃO'"/>
      <CRenderFunction flat :content-to-render="$options.nav" v-show="tipo === 'CLUBE'"/>
      <CRenderFunction flat :content-to-render="$options.nav_federacao" v-show="tipo === 'FEDERAÇÃO'"/> -->
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import nav_admin from "./_nav_admin";
import nav_profissional from "./_nav_profissional";
import nav_recepcionista from "./_nav_recepcionista";

export default {
  name: "TheSidebar",
  nav_admin,
  nav_profissional,
  nav_recepcionista,

  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      this.showImage = !this.showImage
      return this.$store.state.sidebarMinimize;
    },
  },
  data: function() {
    return {
      tipo: "ATLETA",
      showImage: false
    };
  },
  mounted() {
    this.tipo = localStorage.type_name;
  },
};
</script>
<style scoped>
.img-logo {
  width: 200px;
}
.img-logo-menor{
  height: 60px;
}
</style>
